<template lang="pug">
.Filter
  input(
    placeholder='Быстрый поиск...',
    type='text',
    v-model='filterInput',
    :disabled='disabled',
    @input='debounceInput'
  )
  .Filter-icon(
    ref='toggleMapBtn',
    v-if='showMapFilterIcon',
    :class='{ "Filter-icon--active": isMapFilterActive }',
    @mouseover='helperText = isMapFilterActive ? "Отображать в списке все сущности" : "Отображать в списке только сущности, попадающие в область охвата карты"',
    @mouseout='helperText = null',
    @click='toggleMapFilter'
  )
    i.Icon.IconFilterMapMarker
  .Filter-icon(
    ref='showFiltersBtn',
    v-if='showFiltersIcon',
    @mouseover='helperText = isSearchPanelOpened ? "Закрыть панель управления фильтрами" : "Открыть панель управления фильтрами"',
    @mouseout='helperText = null',
    :class='{ "Filter-icon--active": isFiltersActive }',
    @click='openFilters'
  )
    i.Icon.IconFilter
</template>

<script>
import { debounce } from 'debounce'
import helpertext from '@/mixins/helpertext'

export default {
  name: 'quick-filter',
  mixins: [helpertext],
  data() {
    return {
      debounceInput: null,
      filterInput: ''
    }
  },
  props: {
    showMapFilterIcon: {
      default: false,
      type: Boolean
    },
    showFiltersIcon: {
      default: false,
      type: Boolean
    },
    isFiltersActive: {
      default: false,
      type: Boolean
    },
    isSearchPanelOpened: {
      default: false,
      type: Boolean
    },
    isMapFilterActive: {
      default: false,
      type: Boolean
    },
    initialText: {
      default: '',
      type: String
    },
    disabled: Boolean
  },
  created() {
    this.filterInput = this.initialText
    this.debounceInput = debounce(() => {
      this.$emit('filter', this.filterInput)
    }, 500)
  },
  methods: {
    openFilters() {
      this.$emit('openFilters')
      setTimeout(() => {
        this.$refs.showFiltersBtn.dispatchEvent(new Event('mouseover'))
      })
    },
    toggleMapFilter() {
      this.$emit('toggleMapFilter')
      setTimeout(() => {
        this.$refs.toggleMapBtn.dispatchEvent(new Event('mouseover'))
      })
    }
  }
}
</script>
<style lang="scss">
@import '~base';

#app .Filter {
  --iconColor: #{$grey1};
  --activeIconColor: #{$white3};
}

#app[data-theme='dark'] .Filter {
  --iconColor: #{$grey1};
  --activeIconColor: #{$white3};
}
</style>
<style scoped lang="scss">
@import '~base';

.Filter {
  display: flex;
  border-bottom: 1px solid var(--delimiter);

  input {
    flex: 1 1 auto;
    min-width: 0;
    height: 35px;
    padding: 0 15px;
    border: 0;
    outline: 0;
    font-size: 13px;
  }

  &-icon {
    flex: 0 0 40px;
    color: var(--iconColor);
    line-height: 31px;
    border-left: 1px solid var(--delimiter);
    text-align: center;

    &--active {
      background: var(--accentColor);
      color: var(--activeIconColor);
    }

    .Icon {
      display: inline-block;
      font-size: 18px;
    }

    .IconFilterMapMarker {
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Filter.vue